import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useQueryClient } from '@tanstack/react-query';
import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { useLocaleKeys } from '~/i18n';
export const useUpdateInvoiceDashboardPreferences = ()=>{
    const { api } = useStoreActions();
    const queryClient = useQueryClient();
    const { t } = useLocaleKeys('components.invoiceMetricsSection');
    const mutation = useMutationState({
        mutationFn: (param)=>{
            let { cards, updatedAt } = param;
            return api.invoice.saveDashboardPreferences({
                cards,
                updatedAt
            });
        },
        toasts: {
            errorMessage: t.saveErrorToast()
        },
        onMutate: (param)=>{
            let { cards } = param;
            queryClient.cancelQueries({
                queryKey: [
                    QueryKeys.InvoiceDashboardPreferences
                ]
            });
            const previous = queryClient.getQueryData([
                QueryKeys.InvoiceDashboardPreferences
            ]);
            if (previous != null) {
                queryClient.setQueryData([
                    QueryKeys.InvoiceDashboardPreferences
                ], _object_spread_props(_object_spread({}, previous), {
                    cards
                }));
            }
            return {
                previous
            };
        },
        onSuccess: (saved)=>{
            queryClient.setQueryData([
                QueryKeys.InvoiceDashboardPreferences
            ], saved);
        },
        onError: (_error, _variables, context)=>{
            const previous = context === null || context === void 0 ? void 0 : context.previous;
            if (previous != null) {
                queryClient.setQueryData([
                    QueryKeys.InvoiceDashboardPreferences
                ], previous);
            }
            queryClient.invalidateQueries({
                queryKey: [
                    QueryKeys.InvoiceDashboardPreferences
                ]
            });
        }
    });
    return {
        save: mutation.mutate,
        isLoading: mutation.isLoading
    };
};
